import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "juou-card" }

import {
  useBaseAsync,
  useBaseUserStore,
  type HpsfirProTableColumn,
  type HpsfirProTableData,
  type HpsfirProTableFilter,
  type HpsfirProTableGetDataFunction,
} from 'hpsfir-managebase-ui';

import { useApi } from '@/hooks/useApi';
import { ElMessage } from 'element-plus';
import { ref } from 'vue';
import dayjs from 'dayjs';
import { getCurrentRootUrl } from '@/utils';
import { normalizeBizTableColumns } from '@/utils/tableColumns';


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const columns = ref<HpsfirProTableColumn[]>(normalizeBizTableColumns([]));
const tableRef = ref<any>();


const addInitValue = {

};
const conditionsInitValue = {
};


// eslint-disable-next-line max-lines-per-function
const init = useBaseAsync(async() => {
  const weappTplRes = await useApi().weappTplApi.listWeappTplweappTpl({});
  const weappTplOptions = weappTplRes.data.data?.filter((item: any) => item.templateId !== undefined)?.map((item: any) => ({
    value: item.id,
    label: item.name,
  }));

  const wxTplRes = await useApi().wxTplApi.listWxTplwxTpl({});
  const wxTplOptions = wxTplRes.data.data?.map((item: any) => ({
    value: item.id,
    label: item.name,
  }));

  columns.value = normalizeBizTableColumns([
    {
      name: 'name',
      label: '租户名称',
      type: 'string',
      isCondition: true,
      rule: [{ required: true }],
    },
    {
      name: 'logo',
      label: 'Logo',
      rule: [{ required: true }],
      type: 'image',
      action: useApi().uploadImageUrl,
      multiple: false,
      onSuccess(data) {
        console.log(data.data[0]);
        tableRef.value?.tableForm?.setOneFormState('logo', data.data[0]);
      },
    },
    {
      name: 'link',
      label: '租户地址',
      type: 'string',
      render: (scope: any) => {
        const row = scope?.row;
        return row?.id ? (<a href={`/___tenant_${row.id}/login`} target="_blank">{`${getCurrentRootUrl()}/___tenant_${row.id}/login`}</a>) : '';
      },

      hideCreate: true,
      hideEdit: true,
    },
    {
      name: 'phone',
      label: '管理员手机号',
      type: 'string',
      isCondition: true,
      rule: [{ required: true }],
    },
    {
      name: 'password',
      label: '管理员密码',
      type: 'password',
    },
    {
      name: 'weappTplIds',
      label: '授权小程序模板',
      type: 'multiselect',
      options: weappTplOptions,
    },
    {
      name: 'wxTplIds',
      label: '授权H5模板',
      type: 'multiselect',
      options: wxTplOptions,
    },
    {
      name: 'createTime',
      label: '开户时间',
      type: 'string',
      width: 80,
      hideCreate: true,
      hideEdit: true,
      render: (scope: any) => (scope?.row?.createTime ? dayjs(scope.row.createTime).format('YYYY-MM-DD HH:mm:ss') : ''),
    },

  ]);
});


const operates: any[] = [];

const loading = ref(false);


const getData = useBaseAsync<HpsfirProTableGetDataFunction>(async(filter: HpsfirProTableFilter) => {
  try {
    loading.value = true;
    const res = await useApi().tenantApi.pageTenanttenant({
      conditions: Object.entries(filter.conditions).reduce((conditions, [key, val]) => {
        if (val === null || val === undefined || val === '') {
          return conditions;
        }
        conditions[key] = val;
        return conditions;
      }, {} as any),
      pageQuery: {
        page: filter.paginations.page - 1,
        pageSize: filter.paginations.pageSize,
      },


    });
    const tableData: HpsfirProTableData = {
      total: res.data.data?.total || 0,
      data: res.data.data?.data || [],
    };

    return tableData;
  } finally {
    loading.value = false;
  }
});

const formatDeleteInfo = (row: any) => `您正在进行删除(${row.name})操作，请谨慎操作`;


const addFun = useBaseAsync(async(data: any) => {
  await useApi().tenantApi.addTenanttenant(data);
  ElMessage.success('添加成功');
});

const updateFun = useBaseAsync(async(data: any) => {
  await useApi().tenantApi.updateTenanttenant(data);
  ElMessage.success('修改成功');
});
const deleteFun = useBaseAsync(async(data: any) => {
  await useApi().tenantApi.delTenanttenant(data.id);
  ElMessage.success('删除成功');
});


init();


return (_ctx: any,_cache: any) => {
  const _component_HpsfirProTable = _resolveComponent("HpsfirProTable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_HpsfirProTable, {
      ref_key: "tableRef",
      ref: tableRef,
      "export-file-name": "租户管理",
      title: "租户管理",
      paginations: { pageSize: 10 },
      columns: columns.value,
      "get-data": _unref(getData),
      "on-add": _unref(addFun),
      "on-delete": _unref(deleteFun),
      "on-edit": _unref(updateFun),
      loading: loading.value,
      "is-dangder-delete": true,
      "format-dangder-delete-info": formatDeleteInfo,
      "row-key": "id",
      operates: operates,
      "add-init-values": addInitValue,
      "codition-init-values": conditionsInitValue
    }, null, 8, ["columns", "get-data", "on-add", "on-delete", "on-edit", "loading"])
  ]))
}
}

})